export default (refName: string) => !/[/#%]/.test(refName);
